// checking non empty values, could be used for filtering arrays
export const notEmpty = <TValue>(
  value: TValue | null | undefined
): value is TValue => {
  if (value === null || value === undefined) return false

  return true
}
